import { render, staticRenderFns } from "./HeaderPage.vue?vue&type=template&id=2fe51ef6&scoped=true"
import script from "./HeaderPage.vue?vue&type=script&lang=js"
export * from "./HeaderPage.vue?vue&type=script&lang=js"
import style0 from "./HeaderPage.vue?vue&type=style&index=0&id=2fe51ef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe51ef6",
  null
  
)

export default component.exports